import type {ReactNode} from 'react'

import styles from './ComposerToastMessage.module.css'

/**
 * Wraps composer toast text in a marker element.
 *
 * The shared toast is rendered into a portal we cannot pass props to, so this
 * marker class is what lets this package hold the toast at a steady width
 * without restyling the shared component for every caller.
 */
export function composerToastMessage(children: ReactNode): ReactNode {
  return <span className={styles.message}>{children}</span>
}
